import { Box } from "@/storybook-components";

import { sanitizeHref } from "@/lib";
import { useAppSelector } from "@/redux/store/hooks";

const NavLinks = ({ sectionId, loggedInUser }) => {
  const { homePageRevision } = useAppSelector(
    (state) => state.homePageRevision
  );
  const { headerLinks } = useAppSelector((state) => state.navigationLinks);
  const backgroundColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarBackgroundColor;
  const textColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarTextColor;

  const dropdownNode = (item, index) => {
    if (!item.children.length) {
      return (
        <Box
          as="li"
          key={index}
          className="nav-links__list__list-item bg-white user-block"
          color={textColor}
          backgroundColor={loggedInUser === "admin" && backgroundColor}
        >
          <Box
            as="a"
            href={sanitizeHref(item.linkableUrl)}
            aria-expanded="false"
            className="metismenu nav-links__list__list-item__link"
            color={textColor}
            data-testid={`participant-header-mobile-nav-link-${
              item.id ?? index
            }`}
          >
            <span>{item.title}</span>
          </Box>
        </Box>
      );
    }

    return (
      <Box
        as="li"
        key={index}
        className="nav-links__list__list-item bg-white user-block-child"
        color={textColor}
        backgroundColor={loggedInUser === "admin" && backgroundColor}
      >
        <Box
          as="a"
          href={sanitizeHref(item.linkableUrl)}
          aria-expanded="false"
          className="nav-links__list__list-item__link"
          color={textColor}
          data-testid={`participant-header-mobile-nav-dropdown-${
            item.id ?? index
          }`}
        >
          <span>{item.title}</span>
        </Box>
        <Box
          as="ul"
          className="nav-links__list__list-item__child"
          color={textColor}
          backgroundColor={loggedInUser === "admin" && backgroundColor}
        >
          {item.children.map((child, childIndex) => {
            return dropdownNode(child, childIndex);
          })}
        </Box>
      </Box>
    );
  };

  headerLinks.map((l) => !l.children && (l.children = []));

  const links = headerLinks.filter((l) => l.parentId === null);

  return (
    <div className="nav-links">
      <ul className="metismenu nav-links__list">
        {links.map((item, index) => {
          return dropdownNode(item, index);
        })}
      </ul>
    </div>
  );
};

export default NavLinks;
